/* istanbul ignore file */

import { APP_NAME } from '../../configs/app.config';
import { isMobile } from '../userAgent/userAgent.util';

/**
 * native print passed html text
 * @param textToPrint html text to print
 * @returns void
 */
// eslint-disable-next-line max-statements
export const printText = (textToPrint: string): void => {
  const printWindow = window.open('', '_blank');

  if (!printWindow) {
    // eslint-disable-next-line no-console
    console.error('printer.util:printText', { error: 'Can`t print' });
    return;
  }

  const doc = printWindow.document;

  doc.documentElement.innerHTML = '';

  const htmlEl = doc.createElement('html');
  const headEl = doc.createElement('head');
  const bodyEl = doc.createElement('body');

  const titleEl = doc.createElement('title');
  titleEl.textContent = APP_NAME;
  headEl.appendChild(titleEl);

  const styleEl = doc.createElement('style');
  styleEl.textContent = `
    @media print {
      .print-content {
        display: block !important;
      }
    }
    .print-content {
      display: none;
    }
  `;
  headEl.appendChild(styleEl);

  const contentDiv = doc.createElement('div');
  contentDiv.className = 'print-content';
  contentDiv.innerHTML = textToPrint;
  bodyEl.appendChild(contentDiv);

  htmlEl.appendChild(headEl);
  htmlEl.appendChild(bodyEl);
  doc.replaceChild(htmlEl, doc.documentElement);

  printWindow.focus();
  printWindow.print();

  setTimeout(
    () => {
      printWindow.close();
    },
    isMobile() ? 1000 : 50,
  );
};
